{
  "DE": {
    "name": "Germany",
    "divisions": {
      "DE-BW": "Baden-Württemberg",
      "DE-BY": "Bayern",
      "DE-BE": "Berlin",
      "DE-BB": "Brandenburg",
      "DE-HB": "Bremen",
      "DE-HH": "Hamburg",
      "DE-HE": "Hessen",
      "DE-MV": "Mecklenburg-Vorpommern",
      "DE-NI": "Niedersachsen",
      "DE-NW": "Nordrhein-Westfalen",
      "DE-RP": "Rheinland-Pfalz",
      "DE-SL": "Saarland",
      "DE-SN": "Sachsen",
      "DE-ST": "Sachsen-Anhalt",
      "DE-SH": "Schleswig-Holstein",
      "DE-TH": "Thüringen"
    }
  },
  "AT": {
    "name": "Austria",
    "divisions": {
      "AT-1": "Burgenland",
      "AT-2": "Kärnten",
      "AT-3": "Niederösterreich",
      "AT-4": "Oberösterreich",
      "AT-5": "Salzburg",
      "AT-6": "Steiermark",
      "AT-7": "Tirol",
      "AT-8": "Vorarlberg",
      "AT-9": "Wien"
    }
  },
  "CH": {
    "name": "Switzerland",
    "divisions": {
      "CH-AG": "Aargau",
      "CH-AR": "Appenzell Ausser-Rhoden",
      "CH-AI": "Appenzell Inner-Rhoden",
      "CH-BL": "Basel-Landschaft",
      "CH-BS": "Basel-Stadt",
      "CH-BE": "Bern",
      "CH-FR": "Freiburg",
      "CH-GE": "Geneve",
      "CH-GL": "Glarus",
      "CH-GR": "Graubünden",
      "CH-JU": "Jura",
      "CH-LU": "Luzern",
      "CH-NE": "Neuchatel",
      "CH-NW": "Nidwalden",
      "CH-OW": "Obwalden",
      "CH-SG": "Sankt Gallen",
      "CH-SH": "Schaffhausen",
      "CH-SZ": "Schwyz",
      "CH-SO": "Solothurn",
      "CH-TG": "Thurgau",
      "CH-TI": "Ticino",
      "CH-UR": "Uri",
      "CH-VS": "Wallis",
      "CH-VD": "Vaud",
      "CH-ZG": "Zug",
      "CH-ZH": "Zürich"
    }
  }
}